import { render, staticRenderFns } from "./liuliangka.vue?vue&type=template&id=56c995b3&scoped=true&"
import script from "./liuliangka.vue?vue&type=script&lang=js&"
export * from "./liuliangka.vue?vue&type=script&lang=js&"
import style0 from "./liuliangka.vue?vue&type=style&index=0&id=56c995b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c995b3",
  null
  
)

export default component.exports